<template>
  <div>
    <b-form-group
      label="Görsel Üzerinde Metinler"
      label-for="text_status"
    >
      <b-form-checkbox
        id="text_status"
        v-model="itemData.text_status"
        value="1"
        switch
      >
        {{ itemData.text_status === '1'? 'Aktif' : 'Pasif' }}
      </b-form-checkbox>
    </b-form-group>
  </div>
</template>

<script>
import { BFormGroup, BFormCheckbox } from 'bootstrap-vue'

export default {
  name: 'TextStatus',
  components: { BFormGroup, BFormCheckbox },
  computed: {
    itemData() {
      return this.$store.getters['carousel/dataItem']
    },
  },
}
</script>
